export default __webpack_public_path__ + "static/media/mongoDB.fc47a395.svg";